//
// usePushEvent - Subscribe to push events (WebSocket or WebPush)
//
// Usage:
//   usePushEvent('caseUpdate', handleUpdate);
//   usePushEvent('caseMsg', handleMsg, { csid });
//
import { useEffect } from 'react';

import usePush from './usePush';

const usePushEvent = (eventType, callback, filter) => {
  const { push: { subscribe, wsConnected, swAvailable } } = usePush();

  useEffect(
    () => {
      // Subscribe if we have at least one active channel
      if (((!wsConnected) && (!swAvailable)) || (!callback)) return undefined;

      return subscribe(eventType, callback, filter);
    },
    [eventType, callback, filter, subscribe, wsConnected, swAvailable],
  );
};

export default usePushEvent;
